// LiveStreamX — Web Hooks
// Custom React hooks

export {};

import { useEffect, useState } from 'react';
import { http } from '../lib/api';

export interface SubscriptionDto {
  id: string;
  status: string;
  plan: { id: string; name: string } | null;
  endAt: string | null;
  /** Active, unexpired plans. Empty when the tenant is not entitled to anything. */
  plans?: { id: string; name: string; endAt: string | null }[];
}

/**
 * True once the tenant has at least one ACTIVE, unexpired plan — the server
 * refuses stream creation otherwise (see StreamsService.create). `null` while
 * loading so callers can avoid flashing the wrong state.
 *
 * Checks `plans`, not `status`: a row can still say ACTIVE after its `endAt`
 * has passed, and the server treats that as no entitlement. `plans` is the
 * already-filtered list, so this matches what the API will actually allow.
 */
export function useHasActivePlan(): boolean | null {
  const [active, setActive] = useState<boolean | null>(null);
  useEffect(() => {
    void http
      .get<SubscriptionDto | null>('/api/billing/subscription')
      .then((s) => setActive(!!s && s.plans !== undefined ? s.plans.length > 0 : s?.status === 'ACTIVE' && !!s.plan))
      .catch(() => setActive(false));
  }, []);
  return active;
}
